webpackJsonp([149371970566261],{

/***/ 2007:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ScribeTestResult","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"jobId","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"original","type":{"kind":"SCALAR","name":"JSON","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-scribe-test-result-744241ce99d9464dd460.js